import { ConfigService } from './../../services/config/config.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from './../../services/admin/general.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { ENPOINT } from './../../services/endpoint';
import { truncateSync } from 'fs';
import { TranslateService } from '@ngx-translate/core';
import { ResponseModalComponent } from './../../components/response-modal/response-modal.component';


@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.scss'],
  providers: [GeneralService, ConfigService]
})
export class ConfigComponent implements OnInit {
  private basePath;
  public user: User;
  url: string;
  busy: boolean = false;
  busyGuardar: boolean = false;
  busyJob1: boolean = false;
  busyJob2: boolean = false;
  busyLoading: boolean = false;
  busyProcesos: boolean = false;
  pagPedidos;
  tolerancia;
  toleranciaInferior;
  margenComplementos;
  corteCargaComplementos;
  diasAtras;
  tipoValidacion: boolean;
  currentValue: number;
  type: string;
  currentValue2: number;
  type2: string;
  gTipo: boolean;
  modalMensaje;
  closeResult = '';
  loadMensaje: boolean = false;
  titulo;
  mensajeC;
  tituloExt;
  mensajeCExt;
  tituloEliminarMensaje;
  mensajeEliminar;
  arrayDias = [];
  diaSelected;

  toastSicronizado;
  toastError;
  toastErrorMensaje;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private config: ConfigService,
    private storageService: StorageService,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.basePath = ENPOINT.url;

    this.translate.get('texto.toastSincronizado').subscribe(
      text => {
        this.toastSicronizado = text;
      });

    this.translate.get('texto.toastError').subscribe(
      text => {
        this.toastError = text;
      });

    this.translate.get('texto.ErrorCargarMensajes').subscribe(
      text => {
        this.toastErrorMensaje = text;
      });
    this.translate.get('texto.eliminarMensajeTitulo').subscribe(
      text => {
        this.tituloEliminarMensaje = text;
      });
    this.translate.get('texto.eliminarMensaje').subscribe(
      text => {
        this.mensajeEliminar = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.getConfiguracion();
    this.setDiasArray();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Configuración').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  setDiasArray() {
    let dia = {};
    for (let i = 1; i < 31; i++) {
      dia = {"Dia": i};
      this.arrayDias.push(dia)
    }
  }

  getConfiguracion() {
    this.busy = true;
    this.config.obtenerConfiguracion().subscribe(
      data => {
        this.busy = false;
        if (data.propiedad[3] && data.propiedad[3].valorLow) {
          this.pagPedidos = data.propiedad[3].valorLow;
        } else {
          this.pagPedidos = '';
        }
        if (data.propiedad[21] && data.propiedad[21].valorLow) {
          this.tolerancia = data.propiedad[21].valorLow;
        } else {
          this.tolerancia = '';
        }
        if (data.propiedad[22] && data.propiedad[22].valorLow) {
          this.diasAtras = data.propiedad[22].valorLow;
        } else {
          this.diasAtras = '';
        }

        if (data.propiedad[28] && data.propiedad[28].valorLow) {
          this.toleranciaInferior = data.propiedad[28].valorLow;
        } else {
          this.toleranciaInferior = '';
        }

        if (data.propiedad[27].valorLow === '' || data.propiedad[27].valorLow === null || data.propiedad[27].valorLow === undefined) {
          this.tipoValidacion = false;
        } else {
          this.tipoValidacion = data.propiedad[27].valorLow;
        }

        this.margenComplementos = '';
        this.corteCargaComplementos = null;
        if (data.propiedad) { 
          for (let i = 0; i < data.propiedad.length; i++) {
            if (data.propiedad[i].nombre == "TOLERANCIA_COMPLEMENTO_PAGO") {
              this.margenComplementos = data.propiedad[i].valorLow;
            }
            if (data.propiedad[i].nombre == "DIA_CORTE_CARGA_COMPLEMENTO_PAGO") {
              this.corteCargaComplementos = data.propiedad[i].valorLow;
            }
          }
        }

        this.getMensajes();

      },
      err => {
        this.busy = false;
      },
    );
  }

  getMensajes() {
    this.loadMensaje = true;
    var nombre = 'mensaje_bienvenida';
    this.config.obtenerConfiguracionMensaje(nombre).subscribe(
      data => {
        this.loadMensaje = false;

        if (data != null) {
          if (data.propiedad.valorLow != null) {
            this.titulo = data.propiedad.valorLow;
          } else {
            this.titulo = '';
          }
          if (data.propiedad.valorHigh != null) {
            this.mensajeC = data.propiedad.valorHigh;
          } else {
            this.mensajeC = '';
          }
        } else {
          this.titulo = '';
          this.mensajeC = '';
        }
      },
      err => {
        this.loadMensaje = false;
        this.toasterService.pop('error', 'Error', this.toastErrorMensaje);
      },
    );

    var nombreExt = 'mensaje_bienvenida_usd';
    this.config.obtenerConfiguracionMensaje(nombreExt).subscribe(
      data => {
        this.loadMensaje = false;

        if (data != null) {
          if (data.propiedad.valorLow != null) {
            this.tituloExt = data.propiedad.valorLow;
          } else {
            this.tituloExt = '';
          }
          if (data.propiedad.valorHigh != null) {
            this.mensajeCExt = data.propiedad.valorHigh;
          } else {
            this.mensajeCExt = '';
          }
        } else {
          this.tituloExt = '';
          this.mensajeCExt = '';
        }
      },
      err => {
        this.loadMensaje = false;
        this.toasterService.pop('error', 'Error', this.toastErrorMensaje);
      },
    );
  }

  guardarConfiguracion(mensaje) {
    this.busyGuardar = true;
    this.busyLoading = true;
    const pagPedidos = this.pagPedidos;
    const tolerancia = this.tolerancia;
    const toleranciaInferior = this.toleranciaInferior;
    const diasAtras = this.diasAtras;
    let validacion = this.tipoValidacion;

    if (validacion === true) {
      validacion = true;
    } else {
      validacion = false;
    }

    const output = {
      propiedad: [
        { nombre: 'MAX_PAGINA_DE_PEDIDOS', valorLow: pagPedidos },
        { nombre: 'TOLERANCIA-PESOS', valorLow: tolerancia },
        { nombre: 'TOLERANCIA-INFERIOR', valorLow: toleranciaInferior },
        { nombre: 'DIAS-ATRAS', valorLow: diasAtras },
        { nombre: 'VALIDACION_COMPLEMENTO_OBLIGATORIO', valorLow: validacion },
        { nombre: 'TOLERANCIA_COMPLEMENTO_PAGO', valorLow: this.margenComplementos },
        { nombre: 'DIA_CORTE_CARGA_COMPLEMENTO_PAGO', valorLow: this.corteCargaComplementos }
      ]
    };

    const data = JSON.stringify(output);
    this.config.guardarConfiguracion(data).subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      data => {
        this.busyGuardar = false;
        this.busyLoading = false;
        this.openMensaje(mensaje);
      },
      err => {
        this.busyGuardar = false;
        this.busyLoading = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  openMensaje(mensaje) {
    this.modalMensaje = this.modalService.open(mensaje, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getSincronizarSAP() {
    this.busyProcesos = true;
    this.currentValue = 0;
    setTimeout(() => {

      this.type = 'info';
      this.config.sincronizarSAP().subscribe(
        data => {
          
          this.busyJob1 = false;
          this.busyProcesos = false;
          const respuesta = data.status;
          if (respuesta === 'terminado') {
            this.toasterService.pop('success', '', this.toastSicronizado);
            this.currentValue = 100;
          } else {
            this.toasterService.pop('error', 'ERROR', this.toastError);
          }
        },
        err => {
          this.busyJob1 = false;
          this.busyProcesos = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          }
        },
      );
    }, 6000);
  }
  getSincronizarFacturasPagadas() {
    this.busyProcesos = true;
    this.currentValue2 = 0;
    setTimeout(() => {

      this.type = 'info';
      this.config.sincronizarFacturasPagadas().subscribe(
        data => {
          this.busyJob2 = false;
          this.busyProcesos = false;
          const respuesta = data.status;
          if (respuesta === 'terminado') {
            this.toasterService.pop('success', '', this.toastSicronizado);
            this.currentValue2 = 100;
          } else {
            this.toasterService.pop('error', 'ERROR', this.toastError);
          }
        },
        err => {
          this.busyJob2 = false;
          this.busyProcesos = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );
    }, 6000);
  }

  getSincronizarFacturas() {
    this.busyProcesos = true;
    this.currentValue2 = 0;
    setTimeout(() => {

      this.currentValue2 = 100;
      this.type2 = 'info';
      this.config.sincronizarFacturas().subscribe(
        data => {
          this.busyJob2 = false;
          this.busyProcesos = false;
          const respuesta = data.status;
          if (respuesta === 'terminado') {
            this.toasterService.pop('success', '', this.toastSicronizado);
          } else {
            this.toasterService.pop('error', 'ERROR', this.toastError);
          }
        },
        err => {
          this.busyJob2 = false;
          this.busyProcesos = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );
    }, 5000);
  }

  mensajeAProveedores(e) {
    // console.log(e);
  }

  guardarMensaje(titulo, mensaje) {
    var nombre = 'mensaje_bienvenida';
    var valor = titulo;
    var valor2 = mensaje;

    this.config.guardarMensaje(nombre, valor, valor2).subscribe(
      data => {
        if (data != null) {
          this.toasterService.pop('success', data.result.status, data.result.message);

        } else {
          this.toasterService.pop('error', '', 'Error');
        }
        this.getMensajes();

      },
      err => {
        this.loadMensaje = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  eliminarMensaje() {
    var nombre = 'mensaje_bienvenida';
    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloEliminarMensaje;
    modalRef.componentInstance.mensaje1 = this.mensajeEliminar;

    modalRef.result.then((result) => {
      if (result === 'aceptar') {
        this.config.eliminarMensaje(nombre).subscribe(
          data => {
            if (data != null) {
              this.toasterService.pop('success', '', data.result.status);
            } else {
              this.toasterService.pop('error', '', 'Error');
            }
            this.getMensajes();
          },
          err => {
            this.loadMensaje = false;
            if (err.status === 401) {
              this.storageService.openLogout();
            } 
          },
        );
      }

    });


  }

  guardarMensajeExt(tituloExt, mensajeExt) {
    var nombre = 'mensaje_bienvenida_usd';
    var valor = tituloExt;
    var valor2 = mensajeExt;

    this.config.guardarMensajeExtranjero(nombre, valor, valor2).subscribe(
      data => {
        if (data != null) {
          this.toasterService.pop('success', data.result.status, data.result.message);

        } else {
          this.toasterService.pop('error', '', 'Error');
        }
        this.getMensajes();

      },
      err => {
        this.loadMensaje = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  eliminarMensajeExt() {
    var nombre = 'mensaje_bienvenida_usd';
    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloEliminarMensaje;
    modalRef.componentInstance.mensaje1 = this.mensajeEliminar;

    modalRef.result.then((result) => {
      if (result === 'aceptar') {
        this.config.eliminarMensajeExtranjero(nombre).subscribe(
          data => {
            if (data != null) {
              this.toasterService.pop('success', '', data.result.status);
            } else {
              this.toasterService.pop('error', '', 'Error');
            }
            this.getMensajes();
          },
          err => {
            this.loadMensaje = false;
            if (err.status === 401) {
              this.storageService.openLogout();
            }
          },
        );
      }

    });


  }

}



// WEBPACK FOOTER //
// ./src/app/pages/config/config.component.ts